import { ConsentProfileSchema } from '$shared/types/marketing-consent';
import z from 'zod';

export const Schema = z.object({
  consentProfile: ConsentProfileSchema,
  enableCompleteAccount: z.boolean().optional().default(false),
});
